<template>
    <div class="pa-4">
        <div class="content-wrapper" :style="{maxWidth: apis.length * 330 + 'px'}">
            <p class="text-xs-left api mb-3 pl-3">APIs</p>
            <span class="pl-3" v-if="currentProjectType === $const.projectType.POSTPAID">
                {{$t('postpaidRelated.notice1')}}
            </span>
            <div class="box-wrapper" ref="bw">
                <div class="api-box" v-for="api in apis" :key="api.id">
                    <v-card hover style="height: 100%" @click="showDetailsAPIKey(api)">
                        <v-layout row justify-start>
                            <v-flex class="pa-3" style="flex-grow: 0"><img :src="api.icon" alt="icon"/></v-flex>
                            <v-flex class="py-3">
                                <v-layout align-end style="height: 100%; position: relative">
                                    <div style="position: absolute; top: 0; right: 16px;">
                                        <v-switch
                                                v-if="token"
                                                @click.stop.prevent="toggleAPI(api)"
                                                v-model="api.enable"
                                                color="success"
                                                class="pa-0 ma-0"
                                        ></v-switch>
                                    </div>
                                    <h3 class="api-name">{{ api.name }}</h3>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-card-text class="text-sm-left text-ellipsis" color="#707070">
                            {{getApiDescription(api)}}
                        </v-card-text>
                    </v-card>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { mapState } from 'vuex'
import ApiService from '@/services/apis.service'

export default {
    name: 'ListAPIKeys',
    data () {
        return {
            categories: [],
            apisEnable: [],
            search: '',
            headPadding: 0,
            containerWidth: 100
        }
    },
    watch: {
        currentProjectId () {
            if (this.token) {
                this.loadData()
            }
        }
    },
    computed: {
        ...mapState({
            currentProjectId: state => state.user.currentProjectId,
            token: state => state.user.token
        }),
        currentProjectType () {
            return this.$store.getters.currentProjectType
        },
        apis () {
            let apis = []
            for (let i = 0; i < this.categories.length; i++) {
                apis = apis.concat(this.categories[i].apis)
            }
            return apis
        }
    },
    methods: {
        showDetailsAPIKey (apiKey, toDemo = false) {
            this.$router.push(
                this.token && this.currentProjectId
                    ? `/project/${this.currentProjectId}/apis/${apiKey.id}` + (toDemo ? '?tab=service' : '')
                    : `/apis/${apiKey.id}`
            )
        },
        async toggleAPI (apiKey) {
            if (this.currentProjectType === this.$const.projectType.POSTPAID) {
                this.$appService.inform(this.$t('postpaidRelated.notice2'))
            } else {
                ApiService.toggleAPIThenDemo(
                    this.currentProjectId,
                    apiKey,
                    () => this.loadData()
                )
            }
        },
        async loadData () {
            let getListApiCategories = null
            if (this.token && this.currentProjectId) {
                getListApiCategories = await ApiService.getListApiByProjects(this.currentProjectId)
            } else {
                getListApiCategories = await ApiService.getCategories()
            }
            if (getListApiCategories && getListApiCategories.status) {
                this.categories = getListApiCategories.data
            } else {
                this.$appService.toastError(this.$t('canNotLoadApiList'))
            }
        },
        getApiDescription (api) {
            let locale = this.$appService.getLocale()
            if (locale === 'en') {
                return api.description
            } else {
                if (api['description_' + locale]) {
                    return api['description_' + locale]
                }
                return api.description
            }
        }
    },
    async mounted () {
        await this.loadData()
        this.$store.dispatch(this.$actionTypes.LOADING, false)
    }
}
</script>

<style scoped>
    .text-ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
    }

    .api {
        font-size: 29px;
        font-weight: 500;
        color: #707070;
    }

    .api-name {
        font-size: 22px;
        font-weight: 500;
        color: #707070;
    }

    .api-box {
        width: 100%;
        max-width: 300px;
        height: 230px;
        margin: 15px;
    }

    /*.api-box:last-child {*/
    /*    margin: 0;*/
    /*}*/

    /deep/ .v-input--selection-controls__input {
        margin: 0;
    }

    .content-wrapper {
        margin: 0 auto;
    }

    .box-wrapper {
        display: flex;
        flex-wrap: wrap;
    }
</style>
